// Import modules
import Navigation from 'modules/_navigation'
import ObjectFit from 'modules/_object-fit'
import Print from 'modules/_print'
import VideoModal from 'modules/_video-modal'
import FloatingLabels from "./modules/_floating-labels";
import SlideToggle from './modules/_slide-toggle'

// Use modules
Navigation()
ObjectFit()
Print()
VideoModal()
FloatingLabels()
SlideToggle()
